import type { Store } from './api';

export const STORE_AVAILABILITY_REFRESH_MS = 15_000;

export function isPublicOrderingAvailable(store: Pick<Store, 'checkoutAvailable'>): boolean {
  return store.checkoutAvailable;
}
